export default function Logo({ compact = false }) {
  return (
    <span className="inline-flex items-center gap-3 select-none" data-testid="brand-logo">
      <svg viewBox="0 0 64 64" className={compact ? "w-8 h-8" : "w-10 h-10"} aria-hidden="true">
        <defs>
          <linearGradient id="logo-arc" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#0284C7" />
            <stop offset="0.55" stopColor="#0891B2" />
            <stop offset="1" stopColor="#0D9488" />
          </linearGradient>
        </defs>
        <path d="M45 19 A17.5 17.5 0 1 0 45 45" fill="none" stroke="url(#logo-arc)" strokeWidth="5" strokeLinecap="round" />
        <line x1="31" y1="32" x2="40" y2="21.5" stroke="#0D9488" strokeWidth="2.4" />
        <line x1="31" y1="32" x2="43.5" y2="33" stroke="#0369A1" strokeWidth="2.4" />
        <line x1="31" y1="32" x2="39" y2="43.5" stroke="#0284C7" strokeWidth="2.4" />
        <circle cx="31" cy="32" r="5.6" fill="#0284C7" />
        <circle cx="41" cy="20.5" r="3.3" fill="#0D9488" />
        <circle cx="45.5" cy="33" r="3.3" fill="#0369A1" />
        <circle cx="40" cy="45.5" r="3.3" fill="#7C3AED" />
      </svg>
      <span className="leading-none">
        <span className={`font-display font-bold tracking-tight ${compact ? "text-lg" : "text-xl"}`}>
          <span className="text-slate-900">Clarity</span>
          <span className="text-gradient">Point</span>
        </span>
        <span className="block text-[0.55rem] font-mono-tech tracking-[0.42em] text-slate-600 mt-1">CONSULTING</span>
      </span>
    </span>
  );
}
